// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   BePartOfTheMap — two-zone section below the Community Map
   Top: cream — icon + heading + CTA + botanical + disclaimer
   Bottom: dark forest — eyebrow + 4-step process with arrows
   ============================================================ */

.bpm {
  display: flex;
  flex-direction: column;
}

/* ══════════════════════════════════════════════════════════════
   TOP ZONE — cream background
══════════════════════════════════════════════════════════════ */

.bpm__top {
  background: var(--c-cream);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  padding-block: clamp(1.75rem, 3vw, 2.5rem);
}

.bpm__top-inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: clamp(2rem, 5vw, 5rem);
}

/* ── Left: pin icon + heading + sub ── */
.bpm__left {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 2vw, 1.75rem);
}

/* Pin icon circle */
.bpm__pin-circle {
  position: relative;
  width: clamp(48px, 6vw, 72px);
  height: clamp(48px, 6vw, 72px);
  border: 1.5px solid var(--accent);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--accent);
  font-size: clamp(1.1rem, 1.8vw, 1.6rem);
}

/* Small + badge on pin */
.bpm__pin-plus {
  position: absolute;
  bottom: -4px;
  right: -2px;
  font-family: var(--font-body);
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--accent);
  line-height: 1;
  background: var(--c-cream);
  padding: 0 2px;
}

.bpm__left-text {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.bpm__heading {
  font-size: clamp(1.2rem, 2.5vw, 1.9rem);
  color: var(--c-ink);
  margin: 0;
  line-height: 0.95;
}

.bpm__sub {
  font-family: var(--font-body);
  font-size: clamp(0.78rem, 1vw, 0.9rem);
  color: var(--text-muted);
  line-height: 1.55;
  margin: 0;
}

/* ── Centre: CTA button ── */
.bpm__centre {
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.bpm__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.68rem;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--accent);
  text-decoration: none;
  border: 1.5px solid var(--accent);
  border-radius: var(--radius-sm);
  padding: 0.9rem clamp(1.5rem, 3vw, 2.75rem);
  white-space: nowrap;
  transition:
    background var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.bpm__cta:hover {
  background: var(--accent);
  color: var(--on-accent);
}

/* ── Right: botanical + disclaimer ── */
.bpm__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(0.75rem, 1.5vw, 1.25rem);
  position: relative;
}

/* Botanical leaf sprig SVG */
.bpm__botanical {
  /* width: 100%; */
  height: 50%;
  opacity: 0.65;
}

.bpm__botanical img {
  /* height: 100%; */
  width: 50%;
}

.bpm__disclaimer {
  font-family: var(--font-body);
  font-size: clamp(0.72rem, 0.9vw, 0.82rem);
  color: var(--text-muted);
  line-height: 1.55;
  margin: 0;
  text-align: right;
}

/* ══════════════════════════════════════════════════════════════
   BOTTOM ZONE — dark forest background
══════════════════════════════════════════════════════════════ */

.bpm__bottom {
  background: var(--c-forest);
  padding-block: clamp(2rem, 4vw, 3.25rem);
  /* Subtle torn / rough edge at the top — CSS mask approach */
  position: relative;
}

/* Very faint texture overlay */
.bpm__bottom::before {
  content: "";
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.012) 0px, rgba(255, 255, 255, 0.012) 1px, transparent 1px, transparent 4px);
  pointer-events: none;
}

.bpm__bottom-inner {
  display: flex;
  flex-direction: column;
  gap: clamp(1.25rem, 2.5vw, 2rem);
  position: relative;
  z-index: 1;
}

/* Eyebrow */
.bpm__eyebrow {
  color: rgba(220, 204, 180, 0.5) !important;
  letter-spacing: 0.26em;
}

/* ── Steps row ── */
.bpm__steps {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
}

/* Group: step + arrow */
.bpm__step-group {
  display: flex;
  align-items: center;
  flex: 1 1;
  gap: 0;
  min-width: 0;
}

/* Last group has no arrow so flex grows differently */
.bpm__step-group:last-child {
  flex: 0 0 auto;
}

/* Individual step */
.bpm__step {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  flex-shrink: 0;
}

/* Icon circle */
.bpm__step-icon {
  width: clamp(40px, 5.5vw, 58px);
  height: clamp(40px, 5.5vw, 58px);
  border: 1.5px solid rgba(220, 204, 180, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(220, 204, 180, 0.75);
  font-size: clamp(0.9rem, 1.4vw, 1.2rem);
  flex-shrink: 0;
  transition:
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.bpm__step:hover .bpm__step-icon {
  border-color: var(--accent);
  color: var(--accent);
}

/* Number + label row */
.bpm__step-label-row {
  display: flex;
  align-items: baseline;
  gap: 0.35rem;
}

.bpm__step-num {
  font-family: var(--font-body);
  font-size: 0.65rem;
  font-weight: 600;
  color: rgba(220, 204, 180, 0.45);
  letter-spacing: 0.08em;
}

.bpm__step-label {
  font-family: var(--font-body);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: rgba(220, 204, 180, 0.85);
  text-transform: uppercase;
}

/* Description */
.bpm__step-desc {
  font-family: var(--font-body);
  font-size: clamp(0.72rem, 0.9vw, 0.82rem);
  color: rgba(220, 204, 180, 0.5);
  line-height: 1.5;
  margin: 0;
  max-width: 12rem;
}

/* ── Arrow connector ── */
.bpm__arrow {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: clamp(0.5rem, 1.5vw, 1.25rem);
  color: rgba(220, 204, 180, 0.28);
  min-width: clamp(30px, 5vw, 60px);
}

.bpm__arrow svg {
  width: 100%;
  max-width: 52px;
  height: auto;
  display: block;
}

/* ══════════════════════════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════════════════════════ */

@media (max-width: 991.98px) {
  .bpm__top-inner {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
  }
  .bpm__left {
    grid-column: 1 / -1;
  }
  .bpm__centre {
    grid-column: 1;
    justify-content: flex-start;
  }
  .bpm__right {
    grid-column: 2;
  }
}

@media (max-width: 767.98px) {
  .bpm__top-inner {
    grid-template-columns: 1fr;
  }
  .bpm__right {
    justify-content: flex-start;
  }
  .bpm__disclaimer {
    text-align: left;
  }

  .bpm__steps {
    flex-direction: column;
    align-items: flex-start;
    gap: clamp(1rem, 3vw, 1.5rem);
  }

  .bpm__step-group {
    flex-direction: row;
    align-items: flex-start;
    flex: none;
    width: 100%;
    gap: clamp(0.75rem, 2vw, 1.25rem);
  }

  /* On mobile the arrow rotates to point down */
  .bpm__arrow {
    flex: none;
    width: 100%;
    padding-inline: 0;
    padding-left: calc(clamp(40px, 5.5vw, 58px) / 2 - 10px);
    transform: rotate(90deg);
    justify-content: flex-start;
    min-width: auto;
  }
}

/* ── Submit CTA button ── */
.bpm__submit-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: var(--c-rust);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.85rem 2rem;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  cursor: pointer;
  transition: opacity 0.15s;
}
.bpm__submit-cta:hover { opacity: 0.88; }
`, "",{"version":3,"sources":["webpack://./src/components/Home/BePartOfTheMap.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;gEAEgE;;AAEhE;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;EACjC,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB;;gCAE8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;gEAEgE;;AAEhE;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6IAA6I;EAC7I,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,uCAAuC;EACvC,cAAc;EACd;;gCAE8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;;gEAEgE;;AAEhE;EACE;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,iCAAiC;EACnC;;EAEA,8CAA8C;EAC9C;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,uDAAuD;IACvD,wBAAwB;IACxB,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;AACA,yBAAyB,aAAa,EAAE","sourcesContent":["/* ============================================================\n   BePartOfTheMap — two-zone section below the Community Map\n   Top: cream — icon + heading + CTA + botanical + disclaimer\n   Bottom: dark forest — eyebrow + 4-step process with arrows\n   ============================================================ */\n\n.bpm {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   TOP ZONE — cream background\n══════════════════════════════════════════════════════════════ */\n\n.bpm__top {\n  background: var(--c-cream);\n  border-top: 1px solid var(--line);\n  border-bottom: 1px solid var(--line);\n  padding-block: clamp(1.75rem, 3vw, 2.5rem);\n}\n\n.bpm__top-inner {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: clamp(2rem, 5vw, 5rem);\n}\n\n/* ── Left: pin icon + heading + sub ── */\n.bpm__left {\n  display: flex;\n  align-items: center;\n  gap: clamp(1rem, 2vw, 1.75rem);\n}\n\n/* Pin icon circle */\n.bpm__pin-circle {\n  position: relative;\n  width: clamp(48px, 6vw, 72px);\n  height: clamp(48px, 6vw, 72px);\n  border: 1.5px solid var(--accent);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--accent);\n  font-size: clamp(1.1rem, 1.8vw, 1.6rem);\n}\n\n/* Small + badge on pin */\n.bpm__pin-plus {\n  position: absolute;\n  bottom: -4px;\n  right: -2px;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--accent);\n  line-height: 1;\n  background: var(--c-cream);\n  padding: 0 2px;\n}\n\n.bpm__left-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.bpm__heading {\n  font-size: clamp(1.2rem, 2.5vw, 1.9rem);\n  color: var(--c-ink);\n  margin: 0;\n  line-height: 0.95;\n}\n\n.bpm__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.78rem, 1vw, 0.9rem);\n  color: var(--text-muted);\n  line-height: 1.55;\n  margin: 0;\n}\n\n/* ── Centre: CTA button ── */\n.bpm__centre {\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.bpm__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.68rem;\n  letter-spacing: 0.24em;\n  text-transform: uppercase;\n  color: var(--accent);\n  text-decoration: none;\n  border: 1.5px solid var(--accent);\n  border-radius: var(--radius-sm);\n  padding: 0.9rem clamp(1.5rem, 3vw, 2.75rem);\n  white-space: nowrap;\n  transition:\n    background var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n\n.bpm__cta:hover {\n  background: var(--accent);\n  color: var(--on-accent);\n}\n\n/* ── Right: botanical + disclaimer ── */\n.bpm__right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: clamp(0.75rem, 1.5vw, 1.25rem);\n  position: relative;\n}\n\n/* Botanical leaf sprig SVG */\n.bpm__botanical {\n  /* width: 100%; */\n  height: 50%;\n  opacity: 0.65;\n}\n\n.bpm__botanical img {\n  /* height: 100%; */\n  width: 50%;\n}\n\n.bpm__disclaimer {\n  font-family: var(--font-body);\n  font-size: clamp(0.72rem, 0.9vw, 0.82rem);\n  color: var(--text-muted);\n  line-height: 1.55;\n  margin: 0;\n  text-align: right;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   BOTTOM ZONE — dark forest background\n══════════════════════════════════════════════════════════════ */\n\n.bpm__bottom {\n  background: var(--c-forest);\n  padding-block: clamp(2rem, 4vw, 3.25rem);\n  /* Subtle torn / rough edge at the top — CSS mask approach */\n  position: relative;\n}\n\n/* Very faint texture overlay */\n.bpm__bottom::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.012) 0px, rgba(255, 255, 255, 0.012) 1px, transparent 1px, transparent 4px);\n  pointer-events: none;\n}\n\n.bpm__bottom-inner {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.25rem, 2.5vw, 2rem);\n  position: relative;\n  z-index: 1;\n}\n\n/* Eyebrow */\n.bpm__eyebrow {\n  color: rgba(220, 204, 180, 0.5) !important;\n  letter-spacing: 0.26em;\n}\n\n/* ── Steps row ── */\n.bpm__steps {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  width: 100%;\n}\n\n/* Group: step + arrow */\n.bpm__step-group {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 0;\n  min-width: 0;\n}\n\n/* Last group has no arrow so flex grows differently */\n.bpm__step-group:last-child {\n  flex: 0 0 auto;\n}\n\n/* Individual step */\n.bpm__step {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  flex-shrink: 0;\n}\n\n/* Icon circle */\n.bpm__step-icon {\n  width: clamp(40px, 5.5vw, 58px);\n  height: clamp(40px, 5.5vw, 58px);\n  border: 1.5px solid rgba(220, 204, 180, 0.4);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(220, 204, 180, 0.75);\n  font-size: clamp(0.9rem, 1.4vw, 1.2rem);\n  flex-shrink: 0;\n  transition:\n    border-color var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n\n.bpm__step:hover .bpm__step-icon {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Number + label row */\n.bpm__step-label-row {\n  display: flex;\n  align-items: baseline;\n  gap: 0.35rem;\n}\n\n.bpm__step-num {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  font-weight: 600;\n  color: rgba(220, 204, 180, 0.45);\n  letter-spacing: 0.08em;\n}\n\n.bpm__step-label {\n  font-family: var(--font-body);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  color: rgba(220, 204, 180, 0.85);\n  text-transform: uppercase;\n}\n\n/* Description */\n.bpm__step-desc {\n  font-family: var(--font-body);\n  font-size: clamp(0.72rem, 0.9vw, 0.82rem);\n  color: rgba(220, 204, 180, 0.5);\n  line-height: 1.5;\n  margin: 0;\n  max-width: 12rem;\n}\n\n/* ── Arrow connector ── */\n.bpm__arrow {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-inline: clamp(0.5rem, 1.5vw, 1.25rem);\n  color: rgba(220, 204, 180, 0.28);\n  min-width: clamp(30px, 5vw, 60px);\n}\n\n.bpm__arrow svg {\n  width: 100%;\n  max-width: 52px;\n  height: auto;\n  display: block;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════════════════════════════ */\n\n@media (max-width: 991.98px) {\n  .bpm__top-inner {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto auto;\n  }\n  .bpm__left {\n    grid-column: 1 / -1;\n  }\n  .bpm__centre {\n    grid-column: 1;\n    justify-content: flex-start;\n  }\n  .bpm__right {\n    grid-column: 2;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .bpm__top-inner {\n    grid-template-columns: 1fr;\n  }\n  .bpm__right {\n    justify-content: flex-start;\n  }\n  .bpm__disclaimer {\n    text-align: left;\n  }\n\n  .bpm__steps {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: clamp(1rem, 3vw, 1.5rem);\n  }\n\n  .bpm__step-group {\n    flex-direction: row;\n    align-items: flex-start;\n    flex: none;\n    width: 100%;\n    gap: clamp(0.75rem, 2vw, 1.25rem);\n  }\n\n  /* On mobile the arrow rotates to point down */\n  .bpm__arrow {\n    flex: none;\n    width: 100%;\n    padding-inline: 0;\n    padding-left: calc(clamp(40px, 5.5vw, 58px) / 2 - 10px);\n    transform: rotate(90deg);\n    justify-content: flex-start;\n    min-width: auto;\n  }\n}\n\n/* ── Submit CTA button ── */\n.bpm__submit-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: var(--c-rust);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 0.85rem 2rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.bpm__submit-cta:hover { opacity: 0.88; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
